var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v("\n    " + _vm._s(_vm.$t("ContactInformation.Title")) + "\n  ")
    ]),
    _vm._v(" "),
    _vm.contacts.contactInfo
      ? _c(
          "div",
          [
            _c("contact-control", {
              staticClass: "mb-3",
              attrs: {
                title: "ContactInformation.ContentResponsible",
                item: _vm.contacts.contactInfo.contentResponsible,
                required: true
              }
            }),
            _vm._v(" "),
            _c("contact-control", {
              staticClass: "mb-3",
              attrs: {
                title: "ContactInformation.FinancesResponsible",
                item: _vm.contacts.contactInfo.financesResponsible,
                required: true
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }